
import OptimizedImage from '@/components/ui/optimized-image';

const companyLogos = [
  { src: "/lovable-uploads/aisensy.png", alt: "Aisensy" },
  { src: "/lovable-uploads/ck-12.png", alt: "CK-12" },
  { src: "/lovable-uploads/DataAxle.png", alt: "Data Axle" },
  { src: "/lovable-uploads/Fractal.png", alt: "Fractal" },
  { src: "/lovable-uploads/JFrog.png", alt: "JFrog" },
  { src: "/lovable-uploads/Paytm.png", alt: "Paytm" },
  { src: "/lovable-uploads/Shiprocket.png", alt: "Shiprocket" },
  { src: "/lovable-uploads/Sprinto.png", alt: "Sprinto" },
  { src: "/lovable-uploads/thoughtworks.png", alt: "Thoughtworks" },
  { src: "/lovable-uploads/egnyte.png", alt: "Egnyte" },
  { src: "/lovable-uploads/deltek.png", alt: "Deltek" },
  { src: "/lovable-uploads/planview.png", alt: "Planview" },
  { src: "/lovable-uploads/middleware.png", alt: "Middleware" },
  { src: "/lovable-uploads/gruve.png", alt: "Gruve" },
  { src: "/lovable-uploads/sonatype.png", alt: "Sonatype" },
];

const CompaniesTicker = () => {
  return (
    <div className="mt-8">
      <div className="relative overflow-hidden">
        <div className="flex animate-infinite-scroll space-x-12 py-4">
          {[...companyLogos, ...companyLogos].map((logo, index) => (
            <OptimizedImage
              key={index}
              src={logo.src}
              alt={logo.alt}
              className="h-10 w-auto transition-all object-contain"
              width={140}
              height={40}
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompaniesTicker;
